import React, { useEffect } from "react";
import { Container } from "@mui/system";
import { Grid, Typography, Button, styled } from '@mui/material';
import globals from "../globals";
import CardDesign from "../components/carousels/cardsDesign";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import CourseCarousel from "../components/carousels/courseCarousel";
import { useAuth } from "../context/AuthContext";
import LoadingIcon from "../components/loading";


const FavButton = styled(Button)(() => (
    {
        backgroundColor: 'transparent',
        color: globals.colors.textColor,
        borderColor: globals.colors.textColor,
        '&:hover': {
            // backgroundColor: globals.colors.backgroundColor,
            color: globals.colors.textColor,
            borderColor: globals.colors.textColor
        },
        '&.Mui-selected': {
            color: globals.colors.darkRed,
        },
    }
))

const SavedCoursesPage = () => {
    const { token } = useAuth();
    const [courses, setCourses] = React.useState([])
    const [suggestedCourses, setSuggestedCourses] = React.useState([])
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        fetch(globals.apiUrl + '/courses/student/saved', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                //console.log('data', data);
                setCourses(data);
                fetch(globals.apiUrl + '/courses/suggested', {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then(response => response.json())
                    .then(suggestedData => {
                        const notSavedCourses = suggestedData.filter(course => !data.some(c => c.id == course.id));
                        //console.log('notSavedCourses', notSavedCourses);
                        setSuggestedCourses(notSavedCourses);
                        setLoading(false);
                    });
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
            });
    }, []);

    const handleSave = (id) => {
        fetch(globals.apiUrl + `/courses/student/saved/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                //console.log('data', data);
                setCourses(courses.filter(course => course.id !== id));
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    return (
        <Container>
            <Grid container justifyContent={'center'} justifyItems={'center'} textAlign={'center'}>
                <Grid item xs={12} sm={12}>
                    <img src={'saved-courses-page.webp'} width={250} height={270} />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h2" sx={{ color: globals.colors.lightRed, fontSize: 35, fontWeight: 'bold' }}>Запазени курсове</Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h2" sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mt: 2 }}>Всички твои избрани онлайн курсове на едно място!</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={5} sx={{ mt: 3 }} justifyContent={'center'} textAlign={'center'}>
                {loading ? <LoadingIcon /> : courses.length > 0 ? courses.map((course) => (
                    <Grid item xs={12} sm={4}>
                        <CardDesign id={course.id} name={course.title} image={course.image_url} author={course.instructor_name} pic={course.instructor_image_url} price={course.price} duration={course.duration} />
                        <Grid textAlign={'center'}>
                            <FavButton sx={{ textTransform: 'none', fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }}
                                onClick={() => handleSave(course.id)}>Премахни
                                {(course.saved) ? <BookmarkBorderIcon sx={{ color: globals.colors.darkBlue, ml: 1 }} />
                                    : <BookmarkIcon sx={{ color: globals.colors.darkBlue, ml: 1 }} />}
                            </FavButton>

                        </Grid>
                    </Grid>
                )) :
                    <Grid item>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>За момента нямаш закупени курсове.</Typography>
                        <Typography>Може да си избереш следващия си курс от <a href='/courses' style={{ color: globals.colors.lightRed, textDecoration: 'none', fontWeight: 'bold' }}>тук.</a></Typography>
                    </Grid>
                }
            </Grid>

            {suggestedCourses.length > 0 &&
                <Grid container justifyContent={'center'} sx={{ mt: 10 }}>
                    <Grid item>
                        <Typography sx={{ color: globals.colors.lightRed, fontSize: 40, mb: 2 }}><strong>Продължи да разглеждаш</strong></Typography>
                    </Grid>
                    <Grid item>
                        <CourseCarousel courses={suggestedCourses} />
                    </Grid>
                </Grid>
            }
        </Container >
    );
}

export default SavedCoursesPage